<template>
    <div class="my-6 md:my-0">
        <h1 v-if="content.title" class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900">
            {{ content.title }}
        </h1>
        <p v-if="content.subtitle" class="mb-4 font-light md:text-lg line-clamp-3">
            {{ content.subtitle }}
        </p>
        <div v-if="content.text" class="mb-6 font-light md:text-lg" v-html="content.text"></div>
        <a v-if="content.button" type="button" :href="content.button.link"
            class="button" :class="content.button.style">
            {{ content.button.text }}
        </a>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
    content: {
        type: Object,
        required: true
    }
})
</script>